export default "__VITE_ASSET__BX5xo3Vs__"